
import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import Datetime from 'react-datetime'
import "react-datetime/css/react-datetime.css";
import TimePicker from 'react-gradient-timepicker';
var Spinner = require('react-spinkit');
import DrawsCard from './KnockoutCard'
import Modal from 'react-modal';
import {
  FloatingMenu,
  MainButton,
  ChildButton,
  Directions
} from 'react-floating-button-menu';


const customStyles = {
  content : {
    top                   : '15%',
    left                  : '25%',
    right                 : '20%',
    bottom                : 'auto',  
  },
    overlay: {
     background: "rgba(52, 52, 52, 0.8)",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '15'
   }
};

class KnockoutView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      competition_id:this.props.competition_id,
      fixtures:this.props.fixtures,
      levels:this.props.levels,
      selected_fixture:'',
      openUpdatePopup:false,
      courts:this.props.courts,
      selected_fixture_index:'',
      competition_game:'',
      openPopupFootballScoreScreen:false,
      leftOpen: false,
      rightOpen: false,
      selectedEvent:'',
      openPlayerList:false,
      teamSide:'',
      footballMatchLeftTeamScore:{},
      footballMatchRightTeamScore:{},
      competition_game:'',
      game_events:[],
      selected_indexes:{grp:'',round:'',match:''},
      team_list:[]
    };
    this.updateFixture = this.updateFixture.bind(this);
    this.handleEvent = this.handleEvent.bind(this);


    this.styles = {
          chip: {
            margin: 4,
          },
          wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
          },
        };
  }


  componentDidMount() {
      this.getTournamentTeamDetails()
      this.getTeamList()
  }



  getTournamentTeamDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_match_input_for_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'competition_id': this.state.competition_id
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
        console.log('datasdkjfuuihwe')
        console.log(data)
         this.setState(
         {
           competition_game:data.game,
           game_events:data.game_events
         })
        })
       .catch(error => error);
  }
  updateFixture(index){
    if(this.state.fixtures[index].team_one.name != 'BYE' && this.state.fixtures[index].team_two.name != 'BYE' && this.state.fixtures[index].team_one.name != 'TBD' && this.state.fixtures[index].team_two.name != 'TBD'){
      this.setState({selected_fixture:this.state.fixtures[index],openUpdatePopup:true,selected_fixture_index:index})
    }
  }
  onStartTimeChange(date_time){
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
    fixtures[this.state.selected_fixture_index].session_start = moment(date_time.toDate()).format("DD/MM/YYYY hh:mm A")
    this.setState({fixtures: fixtures,selected_fixture:fixtures[this.state.selected_fixture_index]});
  }
  handleCourtChange(e){
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
    fixtures[this.state.selected_fixture_index].court.id = e.target.value
    this.setState({fixtures:fixtures,selected_fixture:fixtures[this.state.selected_fixture_index]})
  }
  changeScore(e,set_key){
    console.log(e.target.value)
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
    if(e.target.id == 'team1_scores'){
      if(fixtures[this.state.selected_fixture_index].team1_scores[set_key] != undefined){
        fixtures[this.state.selected_fixture_index].team1_scores[set_key] = e.target.value
      }else if((fixtures[this.state.selected_fixture_index].team1_scores.length == 0 && set_key == 0) || (fixtures[this.state.selected_fixture_index].team1_scores[set_key-1] != undefined)){
        fixtures[this.state.selected_fixture_index].team1_scores.push(e.target.value)
      }else{
        alert('Please enter set '+(set_key).toString()+ ' score !!')
      } 
    }else if(e.target.id == 'team2_scores'){
      if(fixtures[this.state.selected_fixture_index].team2_scores[set_key] != undefined){
        fixtures[this.state.selected_fixture_index].team2_scores[set_key] = e.target.value
      }else if((fixtures[this.state.selected_fixture_index].team2_scores.length == 0 && set_key == 0) || (fixtures[this.state.selected_fixture_index].team2_scores[set_key-1] != undefined)){
        fixtures[this.state.selected_fixture_index].team2_scores.push(e.target.value)
      }else{
        alert('Please enter set '+(set_key).toString()+ ' score !!')
      }
    }
    this.setState({fixtures:fixtures,selected_fixture:fixtures[this.state.selected_fixture_index]})
  }

  deleteFixtures(arr, attr, value){
      var userPreference;
      if (confirm("IMPORTANT !!\nAre you sure you want to delete?\nAll fixtures and the scores will be deleted permanently !!") == true) {
        userPreference = this.confirmDeleteFixtures();
      } else {
        userPreference = "Delete Cancelled!";
      }
    }
  confirmDeleteFixtures(){
    this.setState({submit_button_pressed:true})
    const url = `${getLocationOrigin()}/tournament/delete_competition_fixtures/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        competition_id:this.state.competition_id,
                        match_type:'knockout_matches'
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
        this.setState({submit_button_pressed:false})
      })
      .then(data => {
        alert(data.message)
        this.setState({submit_button_pressed:false})
        this.props.history.goBack()
       });
  }


  // updateKnockoutMatches(){
  //   console.log(this.state.selected_fixture)
  // }
  updateKnockoutMatches(){
    this.setState({submit_button_pressed:true})
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
    let selected_match = fixtures[this.state.selected_fixture_index]
    let fetch_break = false
    let team1_score_arr_len = selected_match.team1_scores.length
    let team2_score_arr_len = selected_match.team2_scores.length
    let max_len_score_arr = team1_score_arr_len
    let max_score_arr = selected_match.team1_scores
    let min_len_score_arr = team2_score_arr_len
    if(team2_score_arr_len>team1_score_arr_len){
      max_len_score_arr = team2_score_arr_len
      min_len_score_arr = team1_score_arr_len
      max_score_arr=selected_match.team2_scores
    }
    if (selected_match.team1_scores.length != selected_match.team2_scores.length){
      for(let i=min_len_score_arr;i<max_len_score_arr;i++){
        if(max_score_arr[i] != ''){
          fetch_break = true
        }else{
          max_score_arr.splice(i,1)
          i--
          max_len_score_arr--
        }
      }
    }
    for (let i=0;i<min_len_score_arr;i++){
      if ((selected_match.team1_scores[i] == '' && selected_match.team2_scores[i] != '') || (selected_match.team1_scores[i] != '' && selected_match.team2_scores[i] == '')){
        fetch_break = true
      }
    }
    this.setState({fixtures:fixtures},()=>{
      this.updateMatchConfirm(fetch_break)
    })
  }
   getTeamList() {
        const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({team_list: data.teamlist}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  updateMatchConfirm(fetch_break){
    let selected_match = this.state.fixtures[this.state.selected_fixture_index]
    console.log('selected_match')
    console.log(selected_match)
    if((fetch_break == false && this.state.competition_game.id != 1) || this.state.competition_game.id == 1){
      const url = `${getLocationOrigin()}/tournament/update_competition_match/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          match_details:selected_match
                        });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
          console.log(error);
          alert(error.message);
          this.setState({submit_button_pressed:false})
        })
        .then(data => {
          let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
          selected_match = fixtures[this.state.selected_fixture_index]
          if(selected_match.team_one.id == data.winner){
            selected_match.team_one.winner = true
            selected_match.team_two.winner = false
          }else if(selected_match.team_two.id == data.winner){
            selected_match.team_two.winner = true
            selected_match.team_one.winner = false
          }else{
            selected_match.team_one.winner = false
            selected_match.team_two.winner = false
          }
          fixtures[parseInt(data.next_match_no)] = data.next_match
          this.setState({submit_button_pressed:false,fixtures:fixtures,openUpdatePopup:false})
          alert(data.message)
         });
    }else{
      alert('Please enter scores for each team !!')
      this.setState({submit_button_pressed:false})
    }

  }
  openPopup(grp,round,match){
    let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
    let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
    footballMatchLeftTeamScore['match_id'] = this.state.fixtures[this.state.selected_fixture_index].id
    footballMatchRightTeamScore['match_id'] = this.state.fixtures[this.state.selected_fixture_index].id
    let tourn_match = this.state.fixtures[this.state.selected_fixture_index]
    let fixturer_indexes = {}
    fixturer_indexes['grp'] = grp
    fixturer_indexes['round'] = round
    fixturer_indexes['match'] = match
    this.setState({openUpdatePopup:false,openPopupFootballScoreScreen:true,selected_fixture:tourn_match,footballMatchRightTeamScore:footballMatchRightTeamScore,footballMatchLeftTeamScore:footballMatchLeftTeamScore,selected_indexes:fixturer_indexes})
  }
  
  render() {
    console.log(this.state.selected_fixture)
    return(
      <div>
      <div className="col-md-12">
        <div style={{position:'absolute',top:'0px',right:'10px',flexDirection:'row',display:'flex'}}>
        </div>
        {
          this.state.fixtures.length > 0  &&
          <DrawsCard updatedFixture={this.updateFixture} level={this.state.levels} schedule={this.state.fixtures} />
        }
        {this.state.openUpdatePopup &&
          <Dialog
              modal={false}
              open={true}
              autoDetectWindowHeight={true}
              autoScrollBodyContent={true}
              scroll={scroll}
              dividers={scroll === 'paper'}
            >
            <div className="col-md-12" style={styles.table}>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Start time
                </div>
                <div className="col-md-5 input-group">
                    <Datetime 
                      dateFormat="DD/MM/YYYY"
                      onChange={date => this.onStartTimeChange(date)}
                      value={this.state.fixtures[this.state.selected_fixture_index].session_start}/>
                </div>
              </div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Court
                </div>
                <select name="selected_court" style={styles.item_body} value={this.state.selected_fixture.court.id}
                  onChange={(e)=>{this.handleCourtChange(e)}}>
                  <option key={-1} value={null}>..........</option>
                  {this.state.courts.map((court,court_index) =>
                    <option key={court_index} value={court.id}>{court.name}</option>
                    )
                  }
                </select>
              </div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Score {this.state.selected_fixture.team_one.name}
                </div>
                {this.state.competition_game.id != 1 ?
                  ['','',''].map((score,index)=>(
                <input
                  type="text"
                  style={{width:'50px',marginLeft:'5px',borderWidth:'1px',backgroundColor:'#fff'}}
                  placeholder={"Set "+(index+1).toString()}
                  id={"team1_scores"}
                  onChange={(e)=>{this.changeScore(e,index)}}
                  value = {this.state.selected_fixture.team1_scores[index] ? this.state.selected_fixture.team1_scores[index] : ''}
                />
                ))
                  :
                  <button style={{width:'75px',marginLeft:'5px',padding:'8px',backgroundColor:'#fff',borderWidth:'0px',borderRadius:'5px'}}
                    onClick={()=>{this.openPopup()}}
                    >
                    {this.state.selected_fixture.team1_scores[0] ? this.state.selected_fixture.team1_scores[0] : 0}
                  </button>
                }
              </div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Score {this.state.selected_fixture.team_two.name}
                </div>
                {this.state.competition_game.id != 1 ?
                  ['','',''].map((score,index)=>(
                  <input
                    type="text"
                    style={{width:'50px',marginLeft:'5px',borderWidth:'1px',backgroundColor:'#fff'}}
                    placeholder={"Set "+(index+1).toString()}
                    id={"team2_scores"}
                    onChange={(e)=>{this.changeScore(e,index)}}
                    value = {this.state.selected_fixture.team2_scores[index] ? this.state.selected_fixture.team2_scores[index] : ''}
                  />
                ))
                  :
                  <button style={{width:'75px',marginLeft:'5px',padding:'8px',backgroundColor:'#fff',borderWidth:'0px',borderRadius:'5px'}}
                    onClick={()=>{this.openPopup()}}
                    >
                    {this.state.selected_fixture.team2_scores[0] ? this.state.selected_fixture.team2_scores[0] : 0}
                  </button>
                }
              </div>
              <div style={styles.button_submit}>
                <input type="button" className="button1" value="Update" style={{backgroundColor:'rgb(132, 220, 242)',color:'#ffffff'}} onClick={() => {this.updateKnockoutMatches()}} />
                <input type="button" disabled={this.state.submit_button_pressed} className="button1" value="Cancel" style={{backgroundColor:'red',color:'#ffffff'}} onClick={() => {this.setState({openUpdatePopup:false})}} />
              </div>
            </div>
          </Dialog>
        }
        {
            <Dialog
                modal={false}
                open={this.state.openPopupFootballScoreScreen}
                autoDetectWindowHeight={true}
                autoScrollBodyContent={true}
                scroll={scroll}
                dividers={scroll === 'paper'}
              >
                <div style={{position:'absolute',right:10,top:10}}>
                  <img onClick={()=>{this.setState({openPopupFootballScoreScreen:false,openUpdatePopup:true})}} src={require("../../../../img/remove.png")} alt="Image preview" 
                                      style={{
                                          height: "30px",
                                          width: "30px",
                                      }}/>
                </div>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'flex-start'}}>
                  <div>
                    <div style={{textAlign:'center',fontSize:16,fontWeight:'bold',fontColor:'#202124',marginBottom:'10px'}}>
                      {this.state.selected_fixture && this.state.selected_fixture.team_one.name}
                    </div>
                    {this.renderFloatMenu('left')}
                    {this.state.selectedEvent && this.state.leftOpen && 
                      <div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',marginTop:'25px'}}>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            {this.state.selectedEvent.event}
                          </div>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            :
                          </div>
                          <select name="selected_player" style={{width:'200px'}} value={this.state.footballMatchLeftTeamScore['player_id']}
                            onChange={(e)=>{this.handleChangePlayer(e,'left')}}>
                              <option key={-1} value={null}>..........</option>
                              {this.state.team_list.filter(team=>team.id == this.state.selected_fixture.team_two.id)[0]&&
                                this.state.team_list.filter(team=>team.id == this.state.selected_fixture.team_one.id)[0].players.map((player,index)=>(
                                <option key={index} value={player.id}>{player.name}</option>
                              )) }
                          </select>
                        </div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',marginTop:'25px'}}>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            Time
                          </div>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            :
                          </div>
                          <input
                              type="number"
                              style={{width:'200px'}}
                              onChange={(e)=>{this.changeEventTime(e,'left')}}
                              value={this.state.footballMatchLeftTeamScore['event_time']}
                          />
                        </div>
                        <div style={{display:'flex',justifyContent:'center',marginTop:'15px'}}>
                          <input type="button" className="button1" value="Submit" style={{backgroundColor:'rgb(60 203 239)',color:'#ffffff'}} 
                          onClick={() => {this.setState({selectedEvent:''},()=>{this.updateFootballScore('left')})}} />
                        </div>
                      </div>
                    }
                  </div>
                  {(this.state.leftOpen || this.state.rightOpen) &&
                    <div style={{height: '180px',width:'1px',backgroundColor:'#909090',marginTop:'80px'}}></div>
                  }
                  <div>
                    <div style={{textAlign:'center',fontSize:16,fontWeight:'bold',fontColor:'#202124',marginBottom:'10px'}}>
                      {this.state.selected_fixture && this.state.selected_fixture.team_two.name}
                    </div>
                    {this.renderFloatMenu('right')}
                    {this.state.selectedEvent && this.state.rightOpen && 
                      <div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',marginTop:'25px'}}>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            {this.state.selectedEvent.event}
                          </div>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            :
                          </div>
                          <select name="selected_player" style={{width:'200px'}} value={this.state.footballMatchRightTeamScore['player_id']}
                            onChange={(e)=>{this.handleChangePlayer(e,'right')}}>
                              <option key={-1} value={null}>..........</option>
                              {this.state.team_list.filter(team=>team.id == this.state.selected_fixture.team_two.id)[0]&&
                                this.state.team_list.filter(team=>team.id == this.state.selected_fixture.team_two.id)[0].players.map((player,index)=>(
                                <option key={index} value={player.id}>{player.name}</option>
                              ))}
                          </select>
                        </div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',marginTop:'25px'}}>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            Time
                          </div>
                          <div style={{fontWeight: 600,fontSize: '120%'}}>
                            :
                          </div>
                          <input
                              type="number"
                              style={{width:'200px'}}
                              onChange={(e)=>{this.changeEventTime(e,'right')}}
                              value={this.state.footballMatchRightTeamScore['event_time']}
                          />
                        </div>
                        <div style={{display:'flex',justifyContent:'center',marginTop:'15px'}}>
                          <input type="button" className="button1" value="Submit" style={{backgroundColor:'rgb(60 203 239)',color:'#ffffff'}} 
                          onClick={() => {this.setState({selectedEvent:''},()=>{this.updateFootballScore('right')})}} />
                        </div>
                      </div>
                    }
                  </div>
                </div>
                {this.state.selected_fixture &&
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',alignItems:'flex-start',paddingInline:'inherit'}}>
                    <div style={{justifyContent:'center',width:'200px'}}>
                      <div style={{textAlign:'center'}}>
                      <img src={this.state.selected_fixture && this.state.selected_fixture.team_one.logo && this.state.selected_fixture.team_one.logo.includes('http') ? this.state.selected_fixture.team_one.logo : 'https://localhost:8000'+(this.state.selected_fixture && this.state.selected_fixture.team_one && this.state.selected_fixture.team_one.logo)}
                       style={{
                          height: '100px',
                          width: '100px'
                      }}/>
                      </div>
                      <div style={{fontSize:22,color:'#202124',fontFamily: 'Roboto',textAlign:'center',marginTop:'15px'}}>
                        {this.state.selected_fixture.team_one.name}
                      </div>
                    </div>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                      <div style={{fontSize:70,color:'#000',fontWeight:'heavy'}}>
                        {this.state.selected_fixture.team1_scores[0] ? this.state.selected_fixture.team1_scores[0] : 0}
                      </div>
                      <div style={{fontSize:70,color:'#000',fontWeight:'heavy'}}>
                        -
                      </div>
                      <div style={{fontSize:70,color:'#000',fontWeight:'heavy'}}>
                        {this.state.selected_fixture.team2_scores[0] ? this.state.selected_fixture.team2_scores[0] : 0}
                      </div>
                    </div>
                    <div style={{justifyContent:'center',width:'200px'}}>
                      <div style={{textAlign:'center'}}>
                      <img src={this.state.selected_fixture && this.state.selected_fixture.team_two.logo && this.state.selected_fixture.team_two.logo.includes('http') ? this.state.selected_fixture.team_two.logo : 'https://localhost:8000'+(this.state.selected_fixture && this.state.selected_fixture.team_two && this.state.selected_fixture.team_two.logo)}
                       style={{
                          height: '100px',
                          width: '100px'
                      }}/>
                      </div>
                      <div style={{fontSize:22,color:'#202124',fontFamily: 'Roboto',textAlign:'center',marginTop:'15px'}}>
                        {this.state.selected_fixture.team_two.name}
                      </div>
                    </div>
                  </div>
                }




              {this.state.selected_fixture &&
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-around',alignItems:'flex-start'}}>
                  <div>
                    {this.state.selected_fixture.match_events.filter(info=>info.team.id == this.state.selected_fixture.team_one.id).map(info=>(
                      <div style={{position:'relative',display:'flex',flexDirection:'row',justifyContent:'space-between',width:'200px',elevation:4,height:'50px',backgroundColor:'#ffe4c4',alignItems:'center',margin:'5px',paddingInline:'5px'}}>
                        <div disabled={this.state.submit_button_pressed} style={{position:'absolute',top:'-10px',right:'-10px'}} onClick={()=>{this.deleteEventHistory(info.id,'left')}}>
                          <img className="pointer" src={require("../../../../img/remove.png")} style={{width:'25px',height:'25px'}}/>
                        </div>
                        <img onClick={()=>{this.setState({openPopupFootballScoreScreen:false})}} src={info.game_event.name == 'Goal' ? require("../../../../img/goal.png") : info.game_event.name == 'Self goal' ? require("../../../../img/self.png") : info.game_event.name == 'Yellow card' ? require("../../../../img/yellow.png") : require("../../../../img/red.png")} alt="Image preview" 
                                      style={{
                                          height: "30px",
                                          width: "30px",
                                      }}/>
                        <div style={{fontSize:15,color:'#202124',fontFamily: 'Roboto',textAlign:'center',marginLeft:'15px'}}>
                          {info.player &&info.player.name}
                        </div>
                        <div style={{fontSize:16,color:'#000',fontFamily: 'Roboto',textAlign:'center',marginLeft:'15px'}}>
                          {info.event_time && '('+info.event_time+"')"}
                        </div>
                      </div>
                      ))}
                  </div>
                  <div>
                  {this.state.selected_fixture.match_events.filter(info=>info.team.id == this.state.selected_fixture.team_two.id).map(info=>(
                      <div style={{position:'relative',display:'flex',flexDirection:'row',justifyContent:'space-between',width:'200px',elevation:4,height:'50px',backgroundColor:'#ffe4c4',alignItems:'center',margin:'5px',paddingInline:'5px'}}>
                        <div disabled={this.state.submit_button_pressed}  style={{position:'absolute',top:'-10px',right:'-10px'}} onClick={()=>{this.deleteEventHistory(info.id,'right')}}>
                          <img className="pointer" src={require("../../../../img/remove.png")} style={{width:'25px',height:'25px'}}/>
                        </div>
                        <img onClick={()=>{this.setState({openPopupFootballScoreScreen:false})}} src={info.game_event.name == 'Goal' ? require("../../../../img/goal.png") : info.game_event.name == 'Self goal' ? require("../../../../img/self.png") : info.game_event.name == 'Yellow card' ? require("../../../../img/yellow.png") : require("../../../../img/red.png")} alt="Image preview" 
                                      style={{
                                          height: "30px",
                                          width: "30px",
                                      }}/>
                        <div style={{fontSize:15,color:'#202124',fontFamily: 'Roboto',textAlign:'center',marginLeft:'15px'}}>
                          {info.player &&info.player.name}
                        </div>
                        <div style={{fontSize:16,color:'#000',fontFamily: 'Roboto',textAlign:'center',marginLeft:'15px'}}>
                          {info.event_time && '('+info.event_time+"')"}
                        </div>
                    </div>
                    ))}
                  </div>
                </div>
              }
            </Dialog>
          }
      </div>
      {this.state.fixtures.length < 1  &&
        <div style={{position:'absolute', top:'50%', left:'50%'}}>
          <Spinner name="line-scale-pulse-out-rapid" color="rgb(27, 21, 60)"/>
        </div>
      }
      </div>

    );
  }
  deleteEventHistory(event_activity_id,side){
    var userPreference;
    console.log(this.state.changeTempObj)
    if (confirm("Are you sure you want delete?") == true) {
      userPreference = this.confirmDeleteEventHistory(event_activity_id,side);
    } else {
      userPreference = "Save Cancelled!";
    }
  }
  confirmDeleteEventHistory(event_activity_id,side){
    this.setState({submit_button_pressed:true})
    const url = `${getLocationOrigin()}/tournament/delete_football_event_activity/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'event_activity_id': event_activity_id,
                         'team_side':side
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
            let current_fixtures = JSON.parse(JSON.stringify(this.state.selected_fixture))
            current_fixtures.team1_scores[0] = parseInt(data.team1_scores)
            current_fixtures.team2_scores[0] = parseInt(data.team2_scores)
            current_fixtures.match_events = data.match_events
            current_fixtures['have_changes']=true
            fixtures[this.state.selected_fixture_index] = current_fixtures
            this.setState({selected_fixture:current_fixtures,fixtures:fixtures,submit_button_pressed:false})
       })
       .catch(error => error);
  }
  handleChangePlayer(e,side){
    if(side == 'left'){
      let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
      footballMatchLeftTeamScore['player_id'] = e.target.value
      footballMatchLeftTeamScore['team_id'] = this.state.selected_fixture.team_one.id
      footballMatchLeftTeamScore['event'] = this.state.selectedEvent.id
      footballMatchLeftTeamScore['side'] = 'left'
      this.setState({footballMatchLeftTeamScore:footballMatchLeftTeamScore})
    }else if(side == 'right'){
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchRightTeamScore['player_id'] = e.target.value
      footballMatchRightTeamScore['team_id'] = this.state.selected_fixture.team_two.id
      footballMatchRightTeamScore['event'] = this.state.selectedEvent.id
      footballMatchRightTeamScore['side'] = 'right'
      this.setState({footballMatchRightTeamScore:footballMatchRightTeamScore})
    }
  }
  changeEventTime(e,side){
    if(side == 'left'){
      let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
      footballMatchLeftTeamScore['event_time'] = e.target.value
      this.setState({footballMatchLeftTeamScore:footballMatchLeftTeamScore})
    }else if(side == 'right'){
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchRightTeamScore['event_time'] = e.target.value
      this.setState({footballMatchRightTeamScore:footballMatchRightTeamScore})
    }
  }
  updateFootballScore(side){
    let eventObj = ''
    if(side == 'left'){
      eventObj = this.state.footballMatchLeftTeamScore
    }else if(side == 'right'){
      eventObj = this.state.footballMatchRightTeamScore
    }
    const url = `${getLocationOrigin()}/tournament/update_football_match_event/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'match_event': eventObj
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
        let fixtures = JSON.parse(JSON.stringify(this.state.fixtures))
        let current_fixtures = JSON.parse(JSON.stringify(this.state.selected_fixture))
        current_fixtures.team1_scores[0] = parseInt(data.team1_scores)
        current_fixtures.team2_scores[0] = parseInt(data.team2_scores)
        current_fixtures.match_events = data.match_events
        current_fixtures['have_changes']=true
        fixtures[this.state.selected_fixture_index] = current_fixtures
        this.setState({selected_fixture:current_fixtures,fixtures:fixtures})
        })
       .catch(error => error);
  }

    handleEvent(event,dir){
        console.log("handleEvent")
        this.setState({selectedEvent:event,openPlayerList:true,teamSide:dir},()=>{
        if (dir=='left'){
            let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
            footballMatchLeftTeamScore['team_id'] = this.state.selected_fixture.team_one.id
            footballMatchLeftTeamScore['player_id'] = ''
            footballMatchLeftTeamScore['event'] = this.state.selectedEvent.id
            footballMatchLeftTeamScore['side'] = 'left'
            this.setState({footballMatchLeftTeamScore:footballMatchLeftTeamScore})
        }
        if (dir=='right'){
            let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
            footballMatchRightTeamScore['player_id'] = ''
            footballMatchRightTeamScore['team_id'] = this.state.selected_fixture.team_two.id
            footballMatchRightTeamScore['event'] = this.state.selectedEvent.id
            footballMatchRightTeamScore['side'] = 'right'
            this.setState({footballMatchRightTeamScore:footballMatchRightTeamScore})
        }
    })
  }
  renderFloatMenu(dir){
    return(
      <FloatingMenu
        slideSpeed={500}
        direction={dir == 'left' ? Directions.Right : Directions.Left}
        spacing={20}
        isOpen={dir == 'left' ? this.state.leftOpen : this.state.rightOpen}
      >
        <MainButton
          iconResting={<div style={{width:'50px',height:'50px',borderRadius:'35px',backgroundColor:'violet',textAlign:'center',paddingTop:'15px',color:'#fff'}}>+</div>}
          iconActive={<div style={{width:'50px',height:'50px',borderRadius:'35px',backgroundColor:'violet',textAlign:'center',paddingTop:'15px',color:'#fff'}}>x</div>}
          onClick={() => this.setState({ leftOpen: dir == 'left' ? !this.state.leftOpen : this.state.leftOpen,rightOpen: dir == 'right' ? !this.state.rightOpen : this.state.rightOpen})}

        />
        {this.state.game_events.map((event,index)=>(
          <ChildButton
            icon={<div style={{width:'60px',height:'60px',borderRadius:'35px',backgroundColor:event.event == 'Goal' ? 'orange' : event.event == 'Red card' ? 'red' : event.event == 'Yellow card' ? 'yellow' : 'blue' ,textAlign:'center',paddingTop:(event.event == 'Yellow card' || event.event == 'Red card')  ? '10px' : '20px',color:'#fff'}}>{event.event}</div>}
            onClick={() => {this.handleEvent(event,dir)} }
          />
        ))}
      </FloatingMenu>
      )
  }
}
export default KnockoutView



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewKnockoutScreen/knockoutView.js